import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import storage from './storage'
import request from './request'
import config from './config'
import './index.less'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import '../node_modules/swiper/dist/css/swiper.css'
import xss from 'xss'
// import Vconsole from 'vconsole'
import './icons'

import VueAMap from 'vue-amap'
setTimeout(() => {
  Vue.use(VueAMap)
  // 初始化vue-amap
  VueAMap.initAMapApiLoader({
    // 高德key
    key: '145d11185986e70da665ffb49a944a01',
    // 插件集合 （插件按需引入）
    plugin: ['AMap.Geolocation', 'MarkerClusterer', 'AMap.MouseTool', 'AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Geocoder'],
    v: '1.4.4'
  })
}, 0)
Vue.use(VueAwesomeSwiper)
/* eslint-disable */
if (process.env.NODE_ENV !== 'production') require('@/mock')

Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp']

Vue.prototype.$storage = storage
Vue.prototype.$http = request
Vue.prototype.$config = config
Vue.prototype.$xss = xss

// if (storage.get('userid') === 'jiangzefang') {
//   new Vconsole()
// }

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
